import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { containsTree } from '@angular/router/src/url_tree';

@Injectable()
export class ApiClient {
  constructor(
    private httpClient: HttpClient,
  ) {}

  get<T>(path: string, params?: Object): Observable<T> {
    return this.httpClient.get<T>(path, {
      headers: this.defaultHeaders(),
      params: this.httpParams(params)
    });
  }

  post<T>(path: string, body?: Object, contentType: string = 'application/json'): Observable<T> {
    return this.httpClient.post<T>(path, JSON.stringify(body), {
      headers: this.defaultHeaders(contentType)
    });
  }

  patch<T>(path: string, body?: Object, contentType: string = 'application/json'): Observable<T> {
    return this.httpClient.patch<T>(path, JSON.stringify(body), {
      headers: this.defaultHeaders(contentType)
    });
  }

  delete<T>(path: string): Observable<T> {
    return this.httpClient.delete<T>(path, {
      headers: this.defaultHeaders()
    });
  }

  private defaultHeaders(contentType?: string): HttpHeaders {
    let h = new HttpHeaders();
    if ( contentType ) { h = h.set('Content-Type', contentType) }
    const authToken = localStorage.getItem('auth_token');
    if ( authToken ) { h = h.set('Authorization', `Bearer ${authToken}`) }
    return h;
  }

  private httpParams(params: Object): HttpParams {
    if ( params ) {
      return Object.keys(params).reduce((a, name) => {
        if ( Array.isArray(params[name]) ) {
          return params[name].reduce((aa, val) => aa.append(name, val), a);
        } else {
          return a.set(name, params[name]);
        }
      }, new HttpParams());
    }
  }
}



// WEBPACK FOOTER //
// /srv/src/app/common/api-client.service.ts